import { render, staticRenderFns } from "./nature1.vue?vue&type=template&id=6b0a2688&scoped=true&"
import script from "./nature1.vue?vue&type=script&lang=js&"
export * from "./nature1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a2688",
  null
  
)

export default component.exports